import * as React from 'react';
function SvgFaviconApp(props) {
    return (React.createElement("svg", Object.assign({ width: 56, height: 56, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M.698 0h54.604c.385 0 .698.312.698.698v45.819A9.446 9.446 0 0146.523 56H.698A.698.698 0 010 55.295V.698C0 .312.313 0 .698 0z", fill: "#00B5D1" }),
        React.createElement("path", { d: "M3 3h50v43.143A6.857 6.857 0 0146.143 53H3V3z", fill: "#00758D" }),
        React.createElement("path", { d: "M18.951 40H12c0-11.397 2.958-18.632 2.958-18.632C13.997 33.628 18.951 40 18.951 40zM47 13s-22.052 9.01-26.14 27h18.56S26.087 36.39 47 13z", fill: "#fff" })));
}
export default SvgFaviconApp;
//# sourceMappingURL=FaviconApp.js.map